import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "font-size-multiplier";

export default class extends Controller {
  static values = { default: Number, min: Number, max: Number, step: Number }
  static targets = ["label"]

  connect() {
    const multiplierSavedValue = localStorage.getItem(STORAGE_KEY);
    const multiplier = multiplierSavedValue ? Number(multiplierSavedValue) : (this.defaultValue || 1);
    this.setFontSize(multiplier);
  }

  setFontSize(multiplier) {
    multiplier = Math.max(this.minValue, Math.min(this.maxValue, Number(multiplier)));
    document.documentElement.style.setProperty('--app-font-size-multiplier', multiplier);
    this.current = multiplier;
    this.labelTarget.textContent = `${multiplier}X`;

    localStorage.setItem(STORAGE_KEY, multiplier);
  }

  increase() {
    this.setFontSize((this.current || this.defaultValue || 1) + this.stepValue);
  }

  decrease() {
    this.setFontSize((this.current || this.defaultValue || 1) - this.stepValue);
  }

  reset() {
    this.setFontSize(this.defaultValue || 1);
  }
}
